import * as yup from 'yup';

export const publisherSchema = yup.object().shape({
    name: yup.string().required(),
    aboutUri: yup.string().url().required(),
});
